import type { FanResponseDto } from '@api'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import { useOpenChat } from '../../hooks/use-open-chat'
import type { UpcomingBirthday } from '../../types'
import { toDateFormat } from '../utils'

interface Props {
  isOpen: boolean
  onClose: () => void
  birthdays?: Record<string, UpcomingBirthday[]>
}

export function ordinalSuffixOf(i: number) {
  const j = i % 10,
    k = i % 100

  if (j === 1 && k !== 11) {
    return i + 'st'
  }
  if (j === 2 && k !== 12) {
    return i + 'nd'
  }
  if (j === 3 && k !== 13) {
    return i + 'rd'
  }

  return i + 'th'
}

function getOrdinalAge(date: string, birthday: string) {
  const newAge =
    parseInt(date.substring(0, 4)) - parseInt(birthday.substring(0, 4))

  return ordinalSuffixOf(newAge)
}

export const UpcomingBirthdays = ({ isOpen, onClose, birthdays }: Props) => {
  const { handleOpenChat, isChatOpening } = useOpenChat()

  const handleClickMessage = async (id: FanResponseDto['id']) => {
    await handleOpenChat(id)
    onClose()
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      bigDialog
      panelClassName="lg:max-w-[533px]"
    >
      <div className="space-y-6">
        <Dialog.Header>
          <Dialog.Title>Fan Birthdays</Dialog.Title>
        </Dialog.Header>
        <Dialog.Description>
          <div className="max-h-[70vh] overflow-auto ">
            {Object.entries(birthdays ?? {}).map(([date, birthdays]) => (
              <div
                className="space-y-2"
                key={date}
              >
                <p className="sticky top-0 bg-card font-semibold">
                  {toDateFormat(date)}
                </p>
                {birthdays.map(({ onlyfansId, birthday, name }) => (
                  <div
                    className="flex items-center justify-between rounded-md border px-4 py-3"
                    key={onlyfansId}
                  >
                    <p className="font-medium">
                      {name} ({getOrdinalAge(date, birthday)} birthday)
                    </p>
                    <Button
                      onClick={() => handleClickMessage(onlyfansId)}
                      disabled={isChatOpening}
                    >
                      Message
                    </Button>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Dialog.Description>
      </div>
    </Dialog>
  )
}
